import React from 'react';
import { DatePicker, DatePickerProps } from 'components';
import { useField, useFormikContext } from 'formik';

interface Props extends Partial<DatePickerProps> {
  name: string;
}

const FormikDatePicker = ({ name, helperText, ...otherProps }: Props) => {
  const [field, { error, touched }] = useField(name);
  const { setFieldValue } = useFormikContext();
  const errorMessage = touched && error ? error : null;
  return (
    <DatePicker
      {...otherProps}
      {...field}
      error={!!error && touched}
      helperText={errorMessage || helperText}
      onChange={value => setFieldValue(name, value)}
    />
  );
};

export default FormikDatePicker;
